import React from 'react';
import { StyleSheetManager } from 'styled-components';
import reportWebVitals from './reportWebVitals';
import { App } from './app/App';
import { createRoot, hydrateRoot } from 'react-dom/client';
import i18n from './i18n';
import { AppLanguage } from './app/model/enums/AppLanguage';

const langFromUrl = window.location.pathname.split('/')[1];
if ((Object.values(AppLanguage) as string[]).includes(langFromUrl)) {
  i18n.changeLanguage(langFromUrl); // nebo i18n.init({ lng: seg, initImmediate: false });
} else {
  i18n.changeLanguage(AppLanguage.Czech);
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;

// During prerendering, inject styles as plain text so styled-components rules
// are serialized into the static HTML and the page paints styled before
// hydration. Real visitors keep the faster CSSOM injection.
const isPrerendering = '__PRERENDER_INJECTED' in window;

const tree = (
  <React.StrictMode>
    <StyleSheetManager disableCSSOMInjection={isPrerendering}>
      <App />
    </StyleSheetManager>
  </React.StrictMode>
);

// Every prerendered page carries the route it was rendered for (scripts/prerender.js
// sets data-prerendered-route on #root). For any other path the static host
// serves a fallback page (the Czech home) with a 200. That fallback markup does
// NOT match the current URL, so hydrating it leaves the stale prerendered page in
// the DOM forever with the real app rendered separately below it. Only hydrate
// when the served page was rendered for the current route; otherwise do a clean
// client render that discards the mismatched fallback markup.
const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
const servedPageMatchesRoute = rootElement.dataset.prerenderedRoute === currentPath;

if (rootElement.hasChildNodes() && servedPageMatchesRoute) {
  hydrateRoot(rootElement, tree);
} else {
  createRoot(rootElement).render(tree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
